import { render, staticRenderFns } from "./Map.vue?vue&type=template&id=5e997cba&scoped=true"
import script from "./Map.vue?vue&type=script&lang=js"
export * from "./Map.vue?vue&type=script&lang=js"
import style0 from "./Map.vue?vue&type=style&index=0&id=5e997cba&prod&lang=scss&scoped=true"
import style1 from "./Map.vue?vue&type=style&index=1&id=5e997cba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e997cba",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PlaceholderMap: require('/home/runner/work/platform/platform/packages/client/src/components/elements/base/placeholder/templates/map/PlaceholderMap.vue').default,Img: require('/home/runner/work/platform/platform/packages/client/src/components/elements/base/image/Img.vue').default,ContentSwitcher: require('/home/runner/work/platform/platform/packages/client/src/components/elements/base/content-switcher/ContentSwitcher.vue').default,ScriptLoader: require('/home/runner/work/platform/platform/packages/client/src/components/utils/script-loader/ScriptLoader.vue').default,Notification: require('/home/runner/work/platform/platform/packages/client/src/components/elements/base/notification/Notification.vue').default})
